import React from "react";
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";

const AnalyticsHeader = ({ activeView, onChange, studentName }) => {
  const title = studentName
    ? `${studentName}'s SAT Analytics`
    : "My SAT";

  return (
    <Box
      sx={{
        mb: 4,
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        borderRadius: 3,
        px: 3,
        py: 2,
        boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        {/* Title */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>

        {/* Tabs */}
        <ToggleButtonGroup
          value={activeView}
          exclusive
          onChange={(_, val) => val && onChange(val)}
          sx={{
            background: "rgba(0,0,0,0.06)",
            borderRadius: 2,
            p: 0.5,
          }}
        >
          {[
            //{ label: "Overall", value: "overall" },
            { label: "English", value: "english" },
            { label: "Math", value: "math" },
          ].map((tab) => (
            <ToggleButton
              key={tab.value}
              value={tab.value}
              disableRipple
              sx={{
                textTransform: "none",
                fontWeight: 600,
                px: 2.5,
                py: 0.75,
                border: "none",
                borderRadius: 1.5,
                color: "text.primary",

                "&.Mui-selected": {
                  background: "#fff",
                  boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                },

                "&.Mui-selected:hover": {
                  background: "#fff",
                },

                "&:hover": {
                  background: "rgba(255,255,255,0.7)",
                },
              }}
            >
              {tab.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default AnalyticsHeader;
